import React from "react";
import "./mobile-page.scss";
import backgroundImage from "../../assets/images/mobile-background.png";
import AppleStoreScan from "../../assets/images/ios_qr.png";
import PlayStoreScan from "../../assets/images/android_qr.png";
import AppleStoreIconTrukker from "../../assets/images/apple-icon.svg";
import AppleStoreIconAdeed from "../../assets/adeed/images/apple-icon.svg";
import PlayStoreIconTrukker from "../../assets/images/play-store-icon.svg";
import PlayStoreIconAdeed from "../../assets/adeed/images/play-store-icon.svg";
import { Brand, isAdeed } from "../../constants/brand";
import AdeedLogo from "../adeed-brand/adeed-logo";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const AppleStoreIcon = isAdeed ? AppleStoreIconAdeed : AppleStoreIconTrukker;
const PlayStoreIcon = isAdeed ? PlayStoreIconAdeed : PlayStoreIconTrukker;
// TruKKer's mobile page has always linked this App Store URL (AppRedirect uses Brand.iosStoreUrl).
const IosStoreUrl = isAdeed ? Brand.iosStoreUrl : "https://apps.apple.com/in/app/carrier-pulse/id1624013412";

const MobilePage = () => {

    const openLink = (url) => {
        window.open(url, "_blank");
    };
    
    return (
        <div className="mobile-container">
            <div class="background-image">
                <img src={backgroundImage} alt="Background" />
            </div>
            <div class="content">
                <div className="header">
                    {isAdeed ? <AdeedLogo dark height={44} className="logo-adeed" /> : <img src={Brand.logo} alt={Brand.appName} className="logo-trukker" />}
                </div>
                <div className="text-section">
                    <span>Stay On Top Of Your Loads And Earnings.</span>
                    <p><strong>Get The App</strong> to access all features and keep moving.</p>
                </div>

                <div className="store-links">
                    {Brand.androidStoreUrl && <div className="store-card" onClick={() =>
                        openLink(Brand.androidStoreUrl)
                    }>
                        <span className="stores">
                            {/* the QR codes point to the TruKKer Partner app */}
                            {!isAdeed && <img src={PlayStoreScan} alt="Google Play QR" className="scan-img" />}
                            <span className="stores-text-container">
                                <img src={PlayStoreIcon} alt="Google Play Icon" className="icon-img" />
                                <span className="stores-text">
                                    <span>GET IT ON</span>
                                    <strong> Google Play</strong>
                                </span>
                            </span>
                        </span>
                    </div>}
                    {IosStoreUrl && <div className="store-card" onClick={() =>
                        openLink(IosStoreUrl)
                    }>
                        <span className="stores">
                            {!isAdeed && <img src={AppleStoreScan} alt="App Store QR" className="scan-img" />}
                            <span className="stores-text-container">
                                <img src={AppleStoreIcon} alt="app store Icon" className="icon-img" />
                                <span className="stores-text">
                                    <span>Download on the</span>
                                    <strong> App Store</strong>
                                </span>
                            </span>
                        </span>
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default MobilePage;
